import { Navigate } from 'react-router-dom';
import { getDecoded } from '@/lib/auth';

interface Props {
  roles: string[];
  children: React.ReactNode;
  fallback?: string;
}

export function RequireRole({
  roles,
  children,
  fallback = '/overview',
}: Props) {
  const decoded = getDecoded();
  const userRoles = decoded?.roles ?? [];
  const ok = userRoles.some(r => roles.includes(r));
  if (!ok) return <Navigate to={fallback} replace />;
  return <>{children}</>;
}
